module.exports = __webpack_public_path__ + "assets/media/lunch.367e9cc1.mp3";